export default {
  isLogin: function () {
    let curP = new Promise(function (resolve, reject) {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          resolve();
        } else {
          reject('登录后才能进行此操作')
        }
      } catch (e) {
        reject(e)
      }
    })
    return curP
  }
}



// WEBPACK FOOTER //
// ./src/axios/common.js